import React from 'react';
import { Redirect, Route } from 'react-router-dom';



const PrivateVideo = ({ component: Component, ...rest }) => {

    return (
        <Route
            {...rest}
            render={props =>
                localStorage.getItem("bearer_cogen_token") && localStorage.getItem("course_cogen_id") ? (
                    <Component {...props} />
                ) : (
                        <Redirect to="/no-access" />
                    )

            }


        />
    )
}
export default PrivateVideo
